module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/technical/contractor-doc-type/doc-type-grid/doc-type-grid.component.css
// module id = ./src/app/technical/contractor-doc-type/doc-type-grid/doc-type-grid.component.css
// module chunks = main